import React from "react";
import Head from "next/head";

const Config = () => (
  <Head>
    {/*<meta charSet="UTF-8"/>
		<meta httpEquiv="X-UA-Compatible" content="IE=edge"/>
		<meta name="viewport" content="width=device-width,initial-scale=1" />
		<link  href="https://cdnjs.cloudflare.com/ajax/libs/semantic-ui/2.2.11/semantic.min.css" rel="preload" as="style"/>
		<link href="/static/css/carousel.css" rel="stylesheet" type="text/css"/>
		<script type="text/javascript" src="https://maps.googleapis.com/maps/api/js?key=AIzaSyB_cOLS-j94lQivw9vTrRMkj05o5yR92D8&libraries=places"></script>
		<link href="/static/css/custom.css" rel="stylesheet" type="text/css"/>*/}
  </Head>
);

export default Config;
